import { render, staticRenderFns } from "./SummerFestivalIsland.vue?vue&type=template&id=5e9e3d70&scoped=true"
import script from "./SummerFestivalIsland.vue?vue&type=script&lang=js"
export * from "./SummerFestivalIsland.vue?vue&type=script&lang=js"
import style0 from "./SummerFestivalIsland.vue?vue&type=style&index=0&id=5e9e3d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9e3d70",
  null
  
)

export default component.exports